const useCategories = () => {
  const flattenCategories = ({ categories, enabled }) => {
    const flattened = new Map();
    if (!enabled) {
      return flattened;
    }

    function flatten(category) {
      flattened.set(category.id, category.slug);

      if (category.children && category.children.length > 0) {
        category.children.forEach((child) => {
          flatten(child);
        });
      }
    }

    categories.forEach((category) => {
      flatten(category);
    });
    return flattened;
  };

  return {
    flattenCategories,
  };
};

export default useCategories;
